import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import { useSelector, useDispatch } from 'react-redux';
import { stopTour } from '../redux/reducers/joyrideSlice';
import { colorPrimary, colorTextBlack } from '../config/theme';

const TourComponent = ({ sidebarOpen }) => {
  const { steps, tourStart } = useSelector(state => state.joyride);
  const dispatch = useDispatch();

  const { authData } = useSelector(state => state.auth);

  const adminSteps = [
    {
      target: '.step-notification',
      content: 'Tap the bell to receive important updates and alerts.',
      title: 'Notification bell',
      disableBeacon: true,
      placement: 'bottom'
    },
    {
      target: '.step-dashboard',
      content:
        'The Dashboard lets you manage users, locations, and view analytics. You can also track events and schedules through the Calendar, all in one place for easy management.',
      title: 'Dashboard',
      disableBeacon: true,
      placement: 'right'
    },
    {
      target: '.step-administration',
      content:
        'In Administration, open Users for the user list or School to add schools and manage the school list.',
      title: 'Administration',
      disableBeacon: true,
      placement: 'right'
    },
    {
      target: '.step-content-management',
      content:
        'The Admins can upload and manage videos, audio, images, and documents with options to publish, unpublish for easy content control.',
      title: 'Content management',
      disableBeacon: true,
      placement: 'right'
    }
  ];

  useEffect(() => {
    // setRunTour(true);
    if (tourStart && sidebarOpen) {
      const checkElementsExist = setInterval(() => {
        const tourSteps = authData?.roleType === 'Admin' ? adminSteps : steps;
        const allExist = tourSteps.every(step =>
          document.querySelector(step.target)
        );

        if (allExist && authData?.tourGuideFlag) {
          clearInterval(checkElementsExist);
          // setRunTour(true);
        }
      }, 500);

      return () => clearInterval(checkElementsExist);
    }
  }, [tourStart, sidebarOpen, authData?.roleType, steps]);

  const handleJoyrideCallback = ({ action, index, status }) => {
    if (
      ['finished', 'skipped'].includes(status) ||
      action === 'close' ||
      action === 'stop'
    ) {
      dispatch(stopTour());
    }
  };

  return (
    <Joyride
      styles={{
        options: {
          // modal arrow and background color
          arrowColor: '#fff',
          backgroundColor: '#FFFFFF',
          // page overlay color
          //   overlayColor: 'rgba(79, 26, 0, 0.4)',
          primaryColor: colorPrimary,
          textColor: colorTextBlack,
          width: 340,
          zIndex: 1000
        },
        buttonNext: {
          color: '#000'
        },
        tooltip: {
          textAlign: 'left'
        },
        tooltipTitle: {
          textAlign: 'left',
          fontWeight: 'bold',
          fontSize: '16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        },
        tooltipContent: {
          textAlign: 'left',
          display: 'block'
        }
      }}
      steps={authData?.roleType === 'Admin' ? adminSteps : steps}
      // steps={steps}
      run={tourStart && authData?.tourGuideFlag}
      // run={runTour}
      // run={true}
      continuous={true}
      callback={handleJoyrideCallback}
      hideBackButton
      locale={{
        last: 'Ok'
      }}
      disableOverlayClose
      disableScrolling
    />
  );
};

export default TourComponent;
